// extracted by mini-css-extract-plugin
module.exports = {"allCovDiv":"PolicyFarmInformationComponent_allCovDiv__1FNBH"};